import React, { Component } from 'react';
import { TableCell } from '@mui/material';
import { formatPhoneNumberForUi } from '../../utils/formatNumber';

class GridPhoneCell extends Component {
    //props: field, value, row
    render() {
        const formattedNumber = formatPhoneNumberForUi(this.props.value);
        const baseStyle = this.props.styles;
        return (
            <TableCell align="left" sx={{ ...baseStyle }}>
                {formattedNumber}
            </TableCell>
        );
    }
}

export default GridPhoneCell;
